import { Button, Tabs } from '@mantine/core'
import React from 'react'
import { FaCreditCard, FaQrcode } from 'react-icons/fa'
import InputField, { InputFieldMasks, InputFieldTypes } from '../input_field';

export interface PaymentMethodFormProps{

}
export interface PaymentMethodFormHandle{
    getData: () => {paymentType: string, data: any};
}
const PaymentMethodForm : React.ForwardRefRenderFunction<
    PaymentMethodFormHandle,
    PaymentMethodFormProps
> = ({}, ref) => {
    const [paymentType, setPaymentType] = React.useState<"credit" | "pix">("credit");
    const [creditData, setCreditData] = React.useState<any>({});
    const [pixData, setPixData] = React.useState<any>({});

    React.useImperativeHandle(ref, () => ({
        getData: () => ({
            paymentType,
            data: {
                credit: creditData,
                pix: pixData,
            }[paymentType]
        })
    }))

    return <div>
        <Tabs defaultValue={paymentType}>
            <Tabs.Tab
                value="credit"
                onClick={(i) => setPaymentType("credit")}
                icon={<FaCreditCard size={14} />}
            >
                Crédito
            </Tabs.Tab>

            <Tabs.Panel value="credit" pt="xs">
                <CreditForm
                    data={creditData}
                    onChange={d => setCreditData(dt => ({...dt, ...d}))}
                />
            </Tabs.Panel>
        </Tabs>
    </div>
}

export default React.forwardRef(PaymentMethodForm);

const CreditForm = ({ onChange, data }) => {
    const onChangeCard = (d) => onChange({card: {...data?.card, ...d}})
    return <div>
        <InputField
            title="Número do cartão"
            name="number"
            onChange={onChangeCard}
            value={data?.card?.number}
            mask={InputFieldMasks.CUSTOM}
            customMask="9999 9999 9999 9999"
        />
        <InputField
            title="CPF ou CNPJ do proprietário"
            name="cpf"
            onChange={onChange}
            value={data?.cpf}
        />
        <InputField
            title="Bandeira"
            name="brand"
            type={InputFieldTypes.SELECT}
            options={[
                {value: "Visa", label: "Visa"},
                {value: "MasterCard", label: "MasterCard"},
            ]}
            onChange={onChangeCard}
            value={data?.card?.brand}
        />
        <InputField
            title="Nome impresso no cartão"
            name="holder"
            onChange={onChangeCard}
            value={data?.card?.holder}
        />
        <InputField
            title="Data de vencimento"
            name="expiry"
            onChange={onChangeCard}
            value={data?.card?.expiry}
            mask={InputFieldMasks.CUSTOM}
            customMask="99/99"
            maskPlaceholder="MM/YY"
        />
        <InputField
            title="Código de segurança"
            name="cvv"
            onChange={onChangeCard}
            value={data?.card?.cvv}
        />
    </div>
}
